export default {
    auth: {
        login: {
            title: 'Firma Electrónica',
            subtitle: '¡Hola!',
            message: 'Te damos la bienvenida a nuestro modulo de firma electrónica, desde aquí podrás firmar tus documentos de forma ágil y segura.',
        },
        modalKeycloack: {
            title: 'Compañias',
            message: 'Selecciona aquí tu compañia.',
        },
        codeOtp: {
            title: 'Firma Electrónica',
            subtitle: 'Código de verificación',
            message: '¡Revisa tu correo! Te enviamos el código de acceso al correo que tienes asignado, ingresalo a continuación para continuar.',
        },
        tratamientoDatos: {
            title: 'POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS',
            message: 'La presente Política de privacidad y protección de datos forma parte integrante de las condiciones de uso de la compañía',
        },
        modalLogoutConfirm: {
            title: '¿Deseas salir del aplicativo?',
            message: 'Estas a punto de salir del sistema.',
        },
        page404: {
            title: 'ACCESO',
            subtitle: 'DENEGADO',
            messageError1: 'No tiene permisos para acceder al recurso solicitado o no existe.',
            messageError2: '',
        },
    },
    pdfViewer: {
        modalDocFirm: {
            title: '¡Documento Firmado!',
            message: 'No es posible firmar el documento, debido a que su estado es COMPLETADO',
        },
        modalDocSuccessMessages: {
            title: '¡Documento Firmado!',
            message: 'Documento firmado correctamente.',
        },
        modalDocCancel: {
            title: 'Cancelar firma',
            message: 'Estas a punto de cancelar la firma de tu documento, queremos saber las razones por la cual no lo firmaras.',
        },
        modalDocError: {
            title: 'Firma cancelada',
            message: 'El usuario ha cancelado la firma del documento solicitado, argumentando lo siguiente:',
        },
        modalDocProceso: {
            title: '¡OPS!',
            message: 'Lo sentimos, el documento aún se encuentra en proceso de firma por parte de otro usuario. O usted no tiene permisos para realizar el proceso de firma.',
        },
    },
    buttons: {
        login: 'INGRESAR',
        confirm: 'CONFIRMAR',
        save: 'GUARDAR',
        saveLowerCase: 'Guardar',
        send: 'ENVIAR INFORME',
        verify: 'VERIFICAR',
        back: 'VOLVER',
        exit: 'SALIR',
        exitLowerCase: 'Salir',
        aceptPol: 'ACEPTAR POLÍTICA',
        downloadDoc: 'DESCARGAR DOCUMENTO',
    },
};
